export const SET_SECRETARIAS_EXECUTIVAS =
  "SECRETARIAS_EXECUTIVAS/SET_SECRETARIAS_EXECUTIVAS";
export const SET_SECRETARIA_EXECUTIVA =
  "SECRETARIAS_EXECUTIVAS/SET_SECRETARIA_EXECUTIVA";
export const SET_PAGINATION = "SECRETARIAS_EXECUTIVAS/SET_PAGINATION";
